<template lang="pug">
  .changelog
    section
      .max-width
        .breadcrumbs(v-if="isApp")
          ul
            li
              router-link.primary-link(:to="{ name: isAdmin ? 'AdminDashboard' : 'PublicDashboard'}") Dashboard
            li
              span \
            li
              router-link.primary-link(:to="{ name: isAdmin ? 'AdminChangelog' : 'Changelog'}") Changelogs
            li
              span \
            li.selected
              span Create


        //-.fw--back-button(v-else)
            router-link.button(:to="{ name: 'PublicBoard', params: { boardSlug: board.slug}}")
              font-awesome-icon.icon(:icon="['fas', 'arrow-left']")
              span {{ board.name }}

    section
      .max-width
        header.changelog-header
          .tabs
            .row.apart
              .col
                .tab.active
                  h2 Create Changelog
              //-.col(v-if="isAdmin && company.isMember")
                .page-actions
                  router-link.button(
                    :to="{ name: 'BoardSettingsGeneral', params: { boardSlug: board.slug } }"
                  ) Settings
        form(@submit.prevent="submit")
          .row
            .col.max
              .form-field(
                :class="{ error: $v.form.title.$error, 'error-required': !$v.form.title.required }"
              )
                label
                  input(
                    v-model="$v.form.title.$model",
                    type="text",
                    placeholder="Changelog Title"
                  )

              .form-field(
                v-if="form.editor",
                :class="{ error: $v.form.editor.$error, 'error-required': !$v.form.editor.hasDescription }"
              )
                label
                  .form-field-rte
                    editor-content(:editor="form.editor")
            .col.sidebar
              aside

          .row(v-for="feature in form.features")
            .col.max
              board-feature(:feature="feature")
            .col.sidebar
              aside
                ul
                  li(v-for="featureType in featureTypes")
                    label
                      input(type="radio", v-model="feature.type", :value="featureType._id")
                      span {{ featureType.label }}

          .row
            .col.max

              .form-field
                .feature-search
                  h4 Attach a Feature
                  input(type="text", placeholder="Search", v-debounce="search", v-model="feature.search")
                  .feature-search-results(v-if="showResults")
                    .item(v-for="result in feature.results", @click="addFeatureToChangelog(result)")
                      .feature
                        .feature-name
                          h5 {{ result.name }}
                        .feature-stats
                          .feature-stat
                            font-awesome-icon.icon(:icon="['fas','caret-up']")
                            span {{ result.stats.likes }}
                          .feature-stat
                            font-awesome-icon.icon(:icon="['fad','comments']")
                            span {{ result.stats.comments }}
                  .no-search-results(v-if="noResults")
                    p No Results

            .col.sidebar
              aside


          .form-field
            SubmitButton(label="Create", :formState="formState")
            button(type="button", @click="schedule") Schedule
            button.button-link(type="button", @click="saveDraft") Save as a draft

</template>

<script>

import { required } from 'vuelidate/lib/validators'
import { mapState, mapGetters } from 'vuex'
import { form } from '@/mixins/form'
import { Editor, EditorContent } from 'tiptap'
import {
  BulletList,
  ListItem,
  Placeholder,
} from 'tiptap-extensions'

import BoardFeature from '@/components/BoardFeature'

const hasDescription = editor => {
  let passed = false

  if (editor.getHTML() !== '<p></p>') {
    passed = true
  }

  return passed
}

export default {
  name: 'ChangelogCreate',
  mixins: [form],
  components: {
    BoardFeature,
    EditorContent
  },
  data () {
    return {
      formState: 'initial',
      form: {
        title: '',
        editor: null,
        status: '',
        features: []
      },
      feature: {
        search: '',
        results: []
      },
      featureTypes: [],
      statuses: []
    }
  },
  validations: {
    form: {
      title: {
        required
      },
      editor: {
        hasDescription
      }
    }
  },
  beforeMount () {
    console.log('create changeloga')
    this.getFeatureTypes()
    this.getStatuses()
  },
  mounted () {
    this.form.editor = new Editor({
      extensions: [
        new BulletList(),
        new ListItem(),
        new Placeholder({
          emptyEditorClass: 'is-editor-empty',
          emptyNodeClass: 'is-empty',
          emptyNodeText: 'Write something …',
          showOnlyWhenEditable: true,
          showOnlyCurrent: true,
        })
      ]
    })    
  },
  computed: {
    ...mapState({
      company: state => state.company,
    }),
    ...mapGetters({
      boardIds: 'boards/boardIds'
    }),
    showResults () {
      return this.feature.search.length > 0 && this.feature.results.length > 0
    },
    noResults () {
      return this.feature.search.length > 0 && this.feature.results.length === 0      
    },
    isAdmin () {
      return this.$route.matched[0].meta.member
    },
    isApp () {
      //console.log(this.$route)
      return !(this.$route.meta && this.$route.meta.widget)
    }
  },
  methods: {
    getFeatureTypes () {
      this.$axios.get('/changelog/feature-types')
        .then(result => {
          console.log(result.data)
          this.featureTypes = result.data
        })
    },
    getStatuses () {
      this.$axios.get('/changelog/statuses')
        .then(result => {
          console.log('statuses', result.data)
          this.statuses = result.data
        })

    },
    search () {
      let filter = {
        text: this.feature.search,
        board: this.boardIds
      }
      let sort = {
        prop: 'popular'
      }
      this.$axios.post(`feature/search`, { filter, sort })
        .then(result => {
          console.log(result)
          this.feature.results = result.data
        })

      //console.log(filter)
    },
    addFeatureToChangelog (feature) {
      console.log('adding', feature)
      this.feature.search = ''
      this.feature.results = []
      this.form.features.push(feature)
    },
    schedule () {

    },
    saveDraft () {
      console.log('here we is')
      this.submit('Draft')
    },
    submit (statusLabel) {
      console.log(statusLabel)
      //console.log('submit', this.form)

      if (this.__formInvalid()) return

      if (!statusLabel) {
        console.log('setting')
        statusLabel = 'Published'
      }

      console.log('status: ', status)
      console.log('found:', this.statuses.find(status => status.label === statusLabel))
      return
      this.formState = 'pending'

      let form = {
        title: this.form.title,
        description: this.form.editor.getHTML(),
        status: this.statuses.find(status => status.label === status)._id,
        features: this.form.features.map(feature => ({
          feature: feature._id,
          type: feature.type
        }))
      }

      console.log(form)
      //return

      this.$store.dispatch('changelogs/postChangelog', form)
        .then((changelog) => {
          console.log(`result = `, changelog)
          /*this.$router.push({
            name: 'AdminBoard',
            params: {
              boardSlug: board.slug
            }
          })*/
        }, errors => {
          this.formState = 'initial'
          this.error = errors
          console.log(errors)
        })

    }
  },
  watch: {
  },
  beforeDestroy() {
    this.form.editor.destroy()
  }
}

</script>

<style lang="stylus" scoped>

header.changelog-header
  margin-bottom $spacing-2
  +for_breakpoint(mobile)
    display none

aside
  width 370px
.feature-search
  position relative
  h4
    margin-bottom $spacing-2
  input[type="text"]
    padding $spacing
  .feature-search-results
    background-color #fff
    border $border-default
    border-radius $border-radius
    box-shadow 0 6px 12px rgba(0,0,0,0.175)
    position absolute
    margin-top 5px
    //height 100px
    width 100%
    z-index 100
    .item
      border-bottom $border-default
      padding $spacing
      &:last-child
        border-bottom none
  .no-search-results
    background-color #fff
    border $border-default
    border-radius $border-radius
    box-shadow 0 6px 12px rgba(0,0,0,0.175)
    padding $spacing
    position absolute
    margin-top 5px
    //height 100px
    text-align center
    width 100%
    z-index 100
        
  .feature-name
    margin-bottom 5px
  .feature-stats
    font-size $text-size-smaller
    display flex
    .feature-stat
      //border $border-default
      margin-right $spacing
      //padding 2px
      .icon
        margin-right 5px
</style>
